import React, { useEffect, useState } from "react";
import "./Header.css";
import { FaPhoneAlt, FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";
import { BiMenu } from "react-icons/bi";
import { NavLink, useLocation } from "react-router-dom";
const logo = "https://cdn.nudus.app/Images/logo.png";
// import ProductosMenu from "../ProductosMenu/Index";

const Header = () => {
  const [show, setShow] = useState(false);
  const [isLanding, setIsLanding] = useState(false)
  const location = useLocation();

  const showMenu = () => {
    setShow(!show);
  };

  useEffect(() => {
    // Check if the current path is the landing page
    const currentPathMatch = location.pathname === "/landing";
    setIsLanding(currentPathMatch);
  }, [location]);

  return (
    <>
      <div
        style={{
          display: isLanding ? "none" : "flex",
        }}
        className="Header-info"
      >
        <div className="first-phone">
          <i className="Header-icon">
            <FaPhoneAlt />
          </i>
          <span className="Header-Place">Etruria</span>
          <a className="Header-phone" href="tel:3534920770">
            0353 4920770/864
          </a>
        </div>

        <div className="second-phone">
          <span> - </span>
          <i className="Header-icon" style={{ margin: '0' }} display="flex">
            <FaWhatsapp height={18} color='#000' />
          </i>
          <span className="Header-Place"></span>
          <a style={{ marginLeft: '-4px' }} className="Header-phone" href="https://api.whatsapp.com/send/?phone=%2B5493535089899">
            3535089899
          </a>
        </div>

        <div className="second-phone">
          <span> - </span>
          <span className="Header-Place">La Carlota</span>
          <a className="Header-phone" href="tel:3534920770">
            03584 4922568/477
          </a>
        </div>

        <span className="divisor"> - </span>

        <a className="Header-mail" href="mailto:ventas@lumadimaderas.com.ar">
          ventas@lumadimaderas.com.ar
        </a>

        <div className="Header-anchor">
          <a
            href="https://www.instagram.com/lumadi.maderas/"
            className="Header-icon-ig"
          >
            <i className="ig-icon">
              <FaInstagram />
            </i>
          </a>

          <a
            href="https://www.facebook.com/LumadiMaderas/"
            className="Header-icon-fb"
          >
            <i className="fb-icon">
              <FaFacebookF />
            </i>
          </a>

          <a
            className="Header-tienda"
            style={isLanding ? { display: "none" } : {}}
            href="https://lumadimaderas.mercadoshops.com.ar"
            target="_bank"
          >
            Tienda
          </a>
        </div>
      </div>

      <div className="Header-menu-container">
        <div className="Header-menu">
          <div className="logo-container">
            <NavLink to="/">
              <img alt="logo" className={show ? "margin" : null} src={logo} />
            </NavLink>
          </div>

          <div className="menu-container" style={isLanding ? { display: "none" } : {}}> 
            <ul className={show ? "show" : null}>
              <li>
                <NavLink to="/">Inicio</NavLink>
              </li>
              <li>
                <NavLink to="/empresa">Empresa</NavLink>
              </li>
             {/* <li>
                <ProductosMenu />
              </li> */}
              <li>
                <NavLink to="/novedades/">Novedades</NavLink>
              </li>
              <li>
                <a
                  href="https://lumadimaderas.mercadoshops.com.ar/p/contacto"
                  target="_bank"
                >
                  Contacto
                </a>
              </li>
              <li>
                <a
                  href="https://optimizadorlumadi.com.ar/"
                  target="_blank"
                  rel="noreferrer"
                  className="opt-anchor"
                >
                  <span className="Optimizador-link">Optimizador</span>
                </a>
              </li>
            </ul>
          </div>

          <span className="button-menu">
            <button onClick={showMenu} type="button">
              <BiMenu />
            </button>
          </span>
          <div className="menu-container-mobile">
            <ul className={show ? "show" : null}>
              <li>
                <NavLink onClick={() => setShow(false)} to="/">
                  Inicio
                </NavLink>
              </li>
              <li>
                <NavLink onClick={() => setShow(false)} to="/empresa">
                  Empresa
                </NavLink>
              </li>
              {/*<li>
                <ProductosMenu />
              </li> */}
              <li>
                <NavLink onClick={() => setShow(false)} to="/novedades/">
                  Novedades
                </NavLink>
              </li>
              <li>
                <a
                  href="https://lumadimaderas.mercadoshops.com.ar/p/contacto"
                  target="_bank"
                >
                  Contacto
                </a>
              </li>
              <li>
                <a
                  onClick={() => setShow(false)}
                  href="https://optimizadorlumadi.com.ar/"
                  target="_blank"
                  rel="noreferrer"
                  className="opt-anchor"
                >
                  <span className="Optimizador-link">Optimizador</span>
                </a>
              </li>
              <li>
                <a
                  className="Header-tienda-mobile"
                  href="https://lumadimaderas.mercadoshops.com.ar"
                  target="_bank"
                >
                  Tienda
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
